export function language(state = '', { lang, type }) {
    switch (type) {
        case 'GET_LANG':
            return ''
        case 'UPDATE_LANG':
            return lang
        default:
            return state
    }
}
